var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{staticClass:"caption font-weight-bold"},[_vm._v("Tipo de compra")]),_c('div',[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.formData.TIPO_COMPRA,45))+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }